import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// 📎 Obtener adjuntos de un gasto
export const getExpenseAttachments = async (expenseItemId) => {
  const res = await axios.get(
    `${API_URL}/api/expense-items/${expenseItemId}/attachments`,
    { headers: authHeaders() }
  );
  return res.data;
};

// ⬆️ Subir adjunto
export const uploadExpenseAttachment = async (expenseItemId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axios.post(
    `${API_URL}/api/expense-items/${expenseItemId}/attachments`,
    formData,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};

// 🗑 Eliminar adjunto
export const deleteExpenseAttachment = async (attachmentId) => {
  await axios.delete(
    `${API_URL}/api/expense-items/attachments/${attachmentId}`,
    { headers: authHeaders() }
  );
};
